module.exports = __webpack_public_path__ + "img/0.4607e7b3.jpg";